import React, { useState, useEffect, useContext } from 'react'
import { Form } from '../../../components/Form'
import { useGetEntityFormByType } from '../../../hooks/entityFormHook'
import { Box, Container, Typography } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { BackButton } from '../../../components/navigation/BackButton'
import { Fetching } from '../../../components/Fetching'
import { useGetTimeMaterialFormData } from '../hooks'
import { useMutateCreateTimeMaterial } from './hooks'
import SnackBarContext from '../../../context/SnackBarContext'

export const TimeMaterialForm = (props: any) => {
  const { id, tmId } = useParams()
  const navigate = useNavigate()
  const [timeInMaterial, setTimeInMaterial] = useState<any>(null)
  const { data: form, isLoading: isFormLoading, refetch } = useGetEntityFormByType(
    'form',
    'timeAndMaterial'
  )
  const [error, setError] = useState<string | null>(null)
  const { data: formData, isLoading: isFormDataLoading, refetch:isRefetch } =
    useGetTimeMaterialFormData('project', id)
  const { mutateAsync: createTimeInMaterial } = useMutateCreateTimeMaterial(
    'timematerial',
    id
  )
  const { toggleSnackbar } = useContext(SnackBarContext);
  const [isSaving, setIsSaving] = useState(false);

  const onSaveHandler = async () => {
    if (isSaving) {
      // If already saving, do nothing
      return;
    }
    try {
      setIsSaving(true);

      const timeInMaterialPayload = {
        ...timeInMaterial,
        clientEmails: formData.clientEmails,
      };

      const result = await createTimeInMaterial(timeInMaterialPayload);
      navigate(`/projects/${result.project}`);
      toggleSnackbar('TNM report created successfully', 'success');
    } catch (error) {
      console.error('Error saving data:', error);
    } finally {
      setIsSaving(false);
    }
  }

  const onChangeHandler = (formData: any) => {
    const { name } = formData;
    if (!name.trim()) {
      setError(name === '' ? 'T&M name cannot be empty' : 'T&M name cannot start with a space');
    } else {
      formData.name = name.trim()
      setTimeInMaterial(formData);
      setError(null);
    }
  }

  useEffect(() => {
    if (!timeInMaterial && formData) {
      const currentTMData = {
        project: formData.project,
        projectName: formData.projectName,
        projectNumber: formData.projectNumber,
        clientName: formData.clientName,
        name: formData.name ? formData.name : 'T&M Report',
        baseReportNumber: formData.baseReportNumber,
      }
      setTimeInMaterial(currentTMData)
    }
  }, [setTimeInMaterial, formData, timeInMaterial])

    useEffect(() => {
    refetch();
    isRefetch();
  }, []);

  if (isFormLoading || isFormDataLoading) {
    return <Fetching />
  }


  return (
    <>
      <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2 }}>
        <Container maxWidth='lg'>
          <BackButton />
        </Container>
      </Box>
      {form ? (
        <>
          <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2 }}>
            <Container maxWidth='lg'>
              <Typography variant='h4' gutterBottom>
                {tmId ? 'Edit' : 'Create'} {form.formName}
              </Typography>
              {timeInMaterial ? (
                <Form
                  fields={form.fields}
                  onSubmit={onSaveHandler}
                  record={timeInMaterial}
                  externalError={error}
                  onFormDataChange={onChangeHandler}
                  submitLabel='Create'
                  disabled={isSaving}
                />
              ) : null}
            </Container>
          </Box>
        </>
      ) : null}
    </>
  )
}
